// The one translation layer for Apsio's web apps (D61, D63).
// Messages are ICU MessageFormat strings in messages/<locale>.json, keyed by id.
import { IntlMessageFormat } from 'intl-messageformat';
import en from '../messages/en.json' with { type: 'json' };
import ptBR from '../messages/pt-BR.json' with { type: 'json' };
export const locales = ['en', 'pt-BR'];
export const defaultLocale = 'en';
const catalogs = { en, 'pt-BR': ptBR };
/** Picks the best supported locale from an Accept-Language header or a list of tags. */
export function negotiateLocale(requested) {
    const tags = typeof requested === 'string'
        ? requested.split(',').map((part) => part.split(';')[0]?.trim() ?? '')
        : (requested ?? []);
    for (const tag of tags) {
        const lower = tag.toLowerCase();
        if (lower.startsWith('pt'))
            return 'pt-BR';
        if (lower.startsWith('en'))
            return 'en';
    }
    return defaultLocale;
}
/** Returns a translate function for one locale; formatters are compiled once per message. */
export function createTranslator(locale) {
    const cache = new Map();
    return (id, values) => {
        let format = cache.get(id);
        if (!format) {
            format = new IntlMessageFormat(catalogs[locale][id], locale);
            cache.set(id, format);
        }
        return String(format.format(values));
    };
}
//# sourceMappingURL=index.js.map